const UTMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'adgroup',
  'click_id',
]

const searchQueryString = () => new URLSearchParams(window.location.search.toLowerCase());

export const saveUtms = () => {
  const queryString = searchQueryString();

  UTMS.forEach(utm => {
    const selectedUtm = queryString.get(utm);
    if(selectedUtm) {
      window.sessionStorage.setItem(utm, selectedUtm)
    }
  })
}

export const getFormattedUtm = () => (
  `&Origem=${window.sessionStorage.getItem('utm_source')}${UTMS.reduce((prev, next, i) => {
    const selectedUtm = window.sessionStorage.getItem(next);
    return selectedUtm ? `${prev}&${next}=${selectedUtm}` : prev;
  }, '' )}`
)
